/**
 * Created by Carsten Bühler
 * User: c.buehler on 04.05.2018
 * Copyright: xdot GmbH 2018
 */

import React from 'external/react';

import { InlineView, wrapWithInlineFormComponent } from './InlineFormControl';
import {
    FeatureDisplayPlugin,
    GeometryInput,
    getMapConfigStore,
    Map,
    transformGeometryToFeatures
} from 'plugin/map-portlet';
import { AppContext, DataUtil } from 'plugin/liferay-widgets-react-web';
import { Button, FormGroup, HelpBlock } from 'external/react-bootstrap';

const MapConfigStore = getMapConfigStore(AppContext);

// eslint-disable-next-line react/prop-types
const PositionDisplay = ({ item: dataItem, isEditable, startEdit }) => {

    let item = DataUtil.asItem(dataItem);
    let features = item && item.geometry ? transformGeometryToFeatures(dataItem) : [];

    return (
        <InlineView showEditIcon={false}>
            {
                () => (
                    <React.Fragment>
                        <Map
                            defaultFallbackMapConfigType={'static'}
                            plugins={[ FeatureDisplayPlugin ]}
                            features={features}
                            zoom={12}
                        />
                        {
                            isEditable &&
                            <div className="button-box-v">
                                <Button
                                    variant="primary"
                                    onClick={startEdit}
                                >
                                    Bearbeiten
                                </Button>
                            </div>
                        }
                    </React.Fragment>
                )
            }
        </InlineView>
    );
};

// eslint-disable-next-line react/prop-types
const PositionEdit = ({
    value,
    type,
    propName,
    item,
    isSaving,
    isEdited,
    onChange,
    stopEdit,
    startEdit,
    cancel,
    submit,
    reset,
    formError,
    formValidation,
    formValid,
    children,
    formData,
    ...otherProps
}) => {
    value = value || item[propName];
    const validateProps = formValidation ? { validationState: formValidation[propName] ? 'error' : null } : {};

    const defaultMapConfig = DataUtil.asItem(MapConfigStore.getDefaultMapConfig());

    return (
        <FormGroup>
            <GeometryInput
                geometry={formData.geometry}
                type={type}
                handleGeometryChange={onChange}
                drawOptions={{
                    circle: false,
                    circlemarker: false,
                    polyline: true,
                    polygon: true,
                    rectangle: true
                }}
                allowMultipleGeometries={true}
                layerDescriptions={defaultMapConfig && defaultMapConfig.children}
            />

            <div className="button-box-v">
                <Button variant="primary" onClick={stopEdit}>Abbrechen</Button>
                <Button variant="primary" onClick={submit}>Speichern</Button>
            </div>
            {
                formValidation && formValidation[propName] ?
                    <HelpBlock>{formValidation[propName]}</HelpBlock> : null}
        </FormGroup>
    );
};

const InlinePositionFormControl = wrapWithInlineFormComponent(PositionEdit, PositionDisplay);

export default InlinePositionFormControl;



// WEBPACK FOOTER //
// ./js/components/InlinePositionFormControl.jsx